import { PromptDefaultsAdmin } from "@/features/admin/PromptDefaultsAdmin";
import { useAppShell } from "@/shell/app-shell-context";

export function PromptDefaultsRoute() {
  const { token } = useAppShell();
  return <PromptDefaultsAdmin token={token} />;
}
